import profileImg from '../assets/aadarsh.webp';

export const personalInfo = {
  name: "Aadarsh Rajesh Kumar",
  title: "Freelance Digital Marketer In Thiruvalla",
  tagline: "Crafting digital experiences that drive results",
  description: "I build robust software solutions and create data-driven marketing strategies that help businesses thrive in the digital landscape.",
  image: profileImg,
  email: "aadarshkk45@gmail.com",
  phone: "+918921158382",
  location: "Thiruvalla, Kerala"
};

export const socialLinks = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/aadarshrajesh/", icon: "Linkedin" },
  { name: "GitHub", url: "https://github.com/AadarshRajesh", icon: "Github" },
  { name: "Instagram", url: "https://www.instagram.com/aadarshrajeshkumar/", icon: "Instagram" },
  { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61588130793461", icon: "Facebook" },
  { name: "WhatsApp", url: "https://wa.me/+918921158382", icon: "MessageCircle" }
];

export const services = [
  {
    id: 1,
    title: "Web Development",
    description: "Building scalable, performant web applications using modern technologies.",
    icon: "Code2",
    features: ["Full-stack Development", "API Integration", "Cloud Deployment", "Performance Optimization"]
  },
  {
    id: 2,
    title: "Graphic Design",
    description: "Creating stunning visual designs and engaging video content that captivate audiences and strengthen brand identity.",
    icon: "Palette",
    features: ["Logo & Brand Design", "Video Editing", "Motion Graphics", "Social Media Graphics"]
  },
  {
    id: 3,
    title: "SEO Optimization",
    description: "Implementing comprehensive SEO strategies to improve search rankings, organic traffic, and online visibility.",
    icon: "TrendingUp",
    features: ["Keyword Research", "On-page SEO", "Technical SEO", "Analytics & Reporting", "AEO", "GEO"]
  },
  {
    id: 4,
    title: "Social Media Marketing",
    description: "Developing and executing social media campaigns that build brand awareness and drive engagement across platforms.",
    icon: "Share2",
    features: ["Content Strategy", "Campaign Management", "Community Building", "Performance Analytics"]
  },
  {
    id: 5,
    title: "Content Marketing",
    description: "Creating compelling content strategies that attract, engage, and convert your target audience into loyal customers.",
    icon: "FileText",
    features: ["Content Strategy", "Blog Writing", "Email Marketing", "Lead Generation"]
  },
  {
    id: 6,
    title: "Analytics & Insights",
    description: "Leveraging data analytics to uncover insights, track performance, and optimize your digital marketing efforts.",
    icon: "BarChart3",
    features: ["Google Analytics", "Data Visualization", "A/B Testing", "ROI Tracking"]
  }
];

export const faqs = [
  {
    id: 1,
    question: "What makes Aadarsh a top digital marketing specialist in Thiruvalla, Kerala?",
    answer: "Aadarsh stands out as a digital marketing expert in Thiruvalla for his personalized approach to online strategies. With a deep understanding of the digital landscape, he helps businesses create unique strategies and execute them as tailored to their goals. His expertise extends beyond Thiruvalla, making him a trusted name across Kerala."
  },
  {
    id: 2,
    question: "Does Aadarsh provide digital marketing services outside Thiruvalla and Kerala?",
    answer: "Yes, Aadarsh's digital marketing services are not confined to Thiruvalla or Kerala. His reputation as a skilled strategist has earned him clients from all over India and beyond. Whether you're a local business or an international brand, his solutions are designed to deliver measurable results."
  },
  {
    id: 3,
    question: "What services does Aadarsh offer as a digital marketing strategist?",
    answer: "Aadarsh offers a wide range of services, including search engine optimization (SEO), social media marketing (SMM), website development, content marketing, SEO copywriting, and search engine marketing (SEM). His comprehensive skill set ensures that your online presence is optimized for success."
  },
  {
    id: 4,
    question: "How can Aadarsh's SEO expertise benefit my business?",
    answer: "With a strong focus on improving search engine rankings, Aadarsh crafts SEO strategies that drive organic traffic and enhance online visibility. His methods are designed to help businesses stand out in competitive markets, making it easier for potential customers to find you."
  },
  {
    id: 5,
    question: "Can Aadarsh integrate website development with SEO strategies?",
    answer: "Absolutely. Aadarsh ensures that every website he develops aligns with modern SEO practices. This integration creates a seamless experience for both users and search engines, resulting in a site that performs well and captures attention."
  },
  {
    id: 6,
    question: "How does Aadarsh maximize ROI through SEM?",
    answer: "Aadarsh's approach to search engine marketing involves targeted campaigns that connect with the right audience. By leveraging platforms like Google Ads, he creates cost-effective strategies that enhance visibility and drive significant returns on investment."
  },
  {
    id: 7,
    question: "What makes Aadarsh's social media strategies successful?",
    answer: "Aadarsh's social media marketing campaigns are designed to resonate with your target audience. He uses data-driven insights to craft engaging content and build a strong online presence for businesses on platforms like Instagram, Facebook, and LinkedIn."
  },
  {
    id: 8,
    question: "How does content marketing help businesses grow under Aadarsh's guidance?",
    answer: "By creating valuable and relevant content, Aadarsh helps businesses establish themselves as thought leaders in their industry. His content marketing strategies not only engage audiences but also strengthen brand loyalty and trust over time."
  },
  {
    id: 9,
    question: "Why is copywriting an important part of Aadarsh's strategy?",
    answer: "Copywriting bridges the gap between engaging storytelling and search engine optimization. Aadarsh ensures that your content appeals to readers while incorporating the right keywords to boost online visibility."
  },
  {
    id: 10,
    question: "How can businesses get in touch with Aadarsh for digital marketing services?",
    answer: "You can send a quick message on WhatsApp to start a conversation, drop an email for detailed project inquiries, or connect with him on LinkedIn to network and follow his latest digital marketing insights."
  },
  {
    id: 11,
    question: "What does your Web Development service entail?",
    answer: "I specialize in building scalable, performant web applications using modern technologies like React, Node.js, and solid cloud infrastructure to give you a competitive edge."
  },
  {
    id: 12,
    question: "How can your Graphic Design services help my brand?",
    answer: "I focus on creating stunning visual designs and engaging video content that captivate audiences, strengthen brand identity, and make a lasting impression across all digital platforms."
  },
  {
    id: 13,
    question: "What is involved in your SEO Optimization process?",
    answer: "I implement comprehensive SEO strategies to improve search rankings, organic traffic, and online visibility. This includes Keyword Research, On-page SEO, Technical SEO, Analytics & Reporting, AEO (Answer Engine Optimization), and GEO (Generative Engine Optimization)."
  },
  {
    id: 14,
    question: "What are the benefits of your Social Media Marketing campaigns?",
    answer: "I develop and execute social media campaigns that build brand awareness and drive engagement across platforms. This covers end-to-end Content Strategy, Campaign Management, Community Building, and Performance Analytics."
  },
  {
    id: 15,
    question: "How does your Content Marketing strategy convert audiences?",
    answer: "By creating compelling content strategies that attract, engage, and connect, I turn your target audience into loyal customers. My services span Content Strategy, Blog Writing, Email Marketing, and Lead Generation."
  },
  {
    id: 16,
    question: "What insights can your Analytics & Reporting provide?",
    answer: "I leverage data analytics to uncover actionable insights, track performance, and continuously optimize your digital marketing efforts using tools like Google Analytics, Data Visualization, A/B Testing, and ROI Tracking."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Web Development: Trends to Watch in 2026",
    excerpt: "Explore the emerging technologies and frameworks that are reshaping how we build web applications, from AI integration to serverless architectures.",
    author: "Aadarsh Rajesh Kumar",
    date: "2026-01-15",
    category: "Web Development",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=400&fit=crop",
    slug: "future-of-web-development-2026"
  },
  {
    id: 2,
    title: "SEO in the Age of AI: Strategies That Still Work",
    excerpt: "Learn how to adapt your SEO strategy in an AI-driven landscape while maintaining authentic, user-focused content that ranks well.",
    author: "Aadarsh Rajesh Kumar",
    date: "2026-01-10",
    category: "Digital Marketing",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop",
    slug: "seo-strategies-ai-age"
  },
  {
    id: 3,
    title: "Building Scalable React Applications: Best Practices",
    excerpt: "A comprehensive guide to architecting React applications that can grow with your business needs while maintaining performance and code quality.",
    author: "Aadarsh Rajesh Kumar",
    date: "2026-01-05",
    category: "Software Engineering",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&h=400&fit=crop",
    slug: "building-scalable-react-applications"
  }
];

export const aboutContent = {
  heading: "Your Technical & Digital Solutions Expert",
  subheading: "Where Code Meets Strategy",
  paragraphs: [
    "Grow your brand with the Best Freelance Digital Marketer In Thiruvalla, Kerala. I'm Aadarsh, also a proven SEO Expert with 4+ years experience and a 100% project success rate. I combine this with strategic social media marketing and paid advertising to maximize your brand's visibility, generate quality leads, and drive actual sales.",
    "As a Software Engineer and Digital Marketer, my solid engineering background from <a href=\"https://saintgits.org/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-purple-600 dark:text-purple-400 hover:text-yellow-500 dark:hover:text-yellow-400 font-medium transition-colors\">Saintgits College of Engineering</a> and professional internship at <a href=\"https://cda.academy/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-purple-600 dark:text-purple-400 hover:text-yellow-500 dark:hover:text-yellow-400 font-medium transition-colors whitespace-nowrap\">CDA Academy</a> under <a href=\"https://quadcubes.com/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-purple-600 dark:text-purple-400 hover:text-yellow-500 dark:hover:text-yellow-400 font-medium transition-colors\">Quadcubes</a> provide a unique technical edge. I specialize in seamless web development, technical SEO, data-backed content, social media management, and meta ads.",
    "With transparent communication and a passion for staying ahead of industry trends, I'm here to help you succeed in this ever-evolving digital landscape."
  ],
  stats: [
    { label: "Projects Completed", value: "30+" },
    { label: "Happy Clients", value: "20+" },
    { label: "Years Experience", value: "4+" },
    { label: "Success Rate", value: "100%" }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Abhinand",
    role: "CTO, Jackfruit Ltd",
    company: "Jackfruit Ltd",
    image: "https://api.dicebear.com/9.x/avataaars/png?seed=AbhinandJackfruit&size=150&backgroundColor=f2bd0c&mouth%5B%5D=smile&eyes%5B%5D=default&eyebrow%5B%5D=raisedExcitedNatural",
    content: "Aadarsh has a solid understanding of Shopify and e-commerce workflows. He helped us set up and customise our store in a way that was clean, functional, and easy to manage. Good work ethic and clear communication throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Arun K Philip",
    role: "Freelance Software Programmer",
    company: "Independent",
    image: "https://api.dicebear.com/9.x/avataaars/png?seed=ArunKPhilip&size=150&backgroundColor=f2bd0c&mouth%5B%5D=smile&eyes%5B%5D=default&eyebrow%5B%5D=raisedExcitedNatural",
    content: "I reached out to Aadarsh for some graphic design support on a couple of my client projects. His design sense is genuinely good the visuals he put together were polished and saved me a lot of time. Would collaborate again.",
    rating: 5
  },
  {
    id: 3,
    name: "Adwaith K",
    role: "Business Owner",
    company: "Independent",
    image: "https://api.dicebear.com/9.x/avataaars/png?seed=AdwaithK2026&size=150&backgroundColor=f2bd0c&mouth%5B%5D=smile&eyes%5B%5D=default&eyebrow%5B%5D=raisedExcitedNatural",
    content: "Aadarsh built my business website and helped with SEO setup. The site looks professional and loads well. He explained what he was doing at each step, which I appreciated as someone not very technical and is very knowleageable freelance digital marketer in thiruvalla",
    rating: 5
  },
  {
    id: 4,
    name: "Krishna Malliath",
    role: "Content Creator",
    company: "Independent",
    image: "https://api.dicebear.com/9.x/avataaars/png?seed=KrishnaMalliath&size=150&backgroundColor=f2bd0c&mouth%5B%5D=smile&eyes%5B%5D=default&eyebrow%5B%5D=raisedExcitedNatural",
    content: "Aadarsh has a good grasp of content strategy and knows his tools well from Canva to CapCut to scheduling platforms. He helped me structure my content plan and gave practical advice that I could actually follow through on.",
    rating: 5
  }
];
